import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { ImageViewerComponent } from 'app/image-viewer/image-viewer.component';
import { CodaltComponent } from '../../codalt.component';
import { LocalStorage } from '../../local-storage.class';
import { TimelineDocument } from '../../models/timeline-document';
import { TimelineImage } from '../../models/timeline-image.interface';
import { Timeline } from '../../models/timeline.interface';
import { ConfirmDialogService } from '../../services/confirm-dialog-service/confirm-dialog.service';
import { NativeFileViewerService } from '../../services/native-file-viewer/native-file-viewer.service';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { TimelineService } from '../../services/timeline.service';

@Component({
    selector: 'app-timeline-detail',
    templateUrl: './timeline-detail.component.html',
    styleUrls: ['./timeline-detail.component.scss'],
    standalone: false,
})
export class TimelineDetailComponent extends CodaltComponent implements OnInit {
    loading = false;
    timeline: Timeline;
    projectId;
    customerId;

    constructor(
        private timelineService: TimelineService,
        private nativeFileViewer: NativeFileViewerService,
        private location: Location,
        private router: Router,
        private confirmDialogService: ConfirmDialogService,
        private matDialog: MatDialog,
        private confirmDialog: ConfirmDialogService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Tijdlijn');
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.projectId, this.RouteParamnames.timelineId],
            ({ customerId, projectId, timelineId }) => {
                this.projectId = projectId;
                this.customerId = customerId;
                this.getTimeline(timelineId);
            }
        );
    }

    delete() {
        this.confirmDialog
            .confirm('Verwijderen', `Weet je zeker dat je dit artikel wilt verwijderen?`, 'Ja', 'Nee')
            .then(() =>
                this.timelineService
                    .delete(this.timeline.id)
                    .subscribe(() => this.router.navigateByUrl(this.timelineBaseUrl()))
            )
            .catch(() => {});
    }

    openDocument(doc: TimelineDocument) {
        const url = `${this.environment.apiEndpoint}file/thumb?secure=timeline&path=/${this.timeline.id}/${doc.path}&access_token=${LocalStorage.getUserToken()}`;
        if (Capacitor.isNativePlatform()) {
            this.nativeFileViewer.openNativePdf(url, doc.path).catch(error => console.error('open failed', error));
        } else {
            window.open(url);
        }
    }

    openImage(image: TimelineImage) {
        this.matDialog.open(ImageViewerComponent, {
            panelClass: 'image-viewer',
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            data: {
                images: this.timeline.images,
                currentImage: image,
            },
        });
    }

    private getTimeline(slug) {
        this.timelineService.get(slug).subscribe(
            timeline => {
                timeline.data.images = timeline.data.images.map(image => {
                    image.image_url = `${this.environment.apiEndpoint}public/uploads/timelineimages/${image.path}?id=${timeline.data.id}`;
                    return image;
                });
                this.timeline = timeline.data;
                this.pageTitleService.setTitle('Tijdlijn', this.timeline.title);

                this.location.replaceState(`${this.timelineBaseUrl()}/${timeline.data.slug}`);
            },
            () => {
                if (this.customerId) {
                    this.router.navigateByUrl(this.timelineBaseUrl());
                } else {
                    this.router.navigateByUrl(`/${this.Routenames.timeline}`);
                }
            }
        );
    }

    private timelineBaseUrl(): string {
        return this.customerId
            ? `${this.Routenames.customers}/${this.customerId}/${this.Routenames.projects}/${this.projectId}/${this.Routenames.timeline}`
            : this.Routenames.timeline;
    }
}
